// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.human-readable-pane {
  display: block;
  min-width: 0;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.human-readable-pane__container {
  display: block;
  min-width: 0;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}

.human-readable-pane__frame {
  display: block;
  border: 1px solid;
  padding: 1rem;
  height: var(--human-readable-pane-height, 30rem);
  min-width: 0;
  max-width: 100%;
  width: 100%;
  box-sizing: border-box;
  resize: both;
  overflow: auto;
}

.human-readable-pane__frame--iframe {
  padding: 0;
  overflow: hidden;
  width: 100%;
  max-width: 100%;
  min-height: 18rem;
  background: var(--color-background, white);
}

.human-readable-pane__frame--markdown {
  overflow-wrap: anywhere;
  word-break: break-word;
}

.human-readable-pane__frame--plain-text {
  font-family: monospace;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.human-readable-pane__frame--markdown > * {
  max-width: 100%;
  box-sizing: border-box;
}

.human-readable-pane__frame--markdown img,
.human-readable-pane__frame--markdown video,
.human-readable-pane__frame--markdown canvas,
.human-readable-pane__frame--markdown iframe {
  max-width: 100%;
  height: auto;
}

.human-readable-pane__frame--markdown pre,
.human-readable-pane__frame--markdown code {
  max-width: 100%;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.human-readable-pane__frame--markdown pre {
  white-space: pre-wrap;
}

.human-readable-pane__frame--markdown table {
  display: block;
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  box-sizing: border-box;
}

.human-readable-pane__frame--markdown th,
.human-readable-pane__frame--markdown td {
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.human-readable-pane[data-layout='mobile'] .human-readable-pane__frame {
  padding: 0.75rem;
  resize: none;
  min-width: 0;
}

.human-readable-pane[data-layout='mobile'] .human-readable-pane__frame--markdown,
.human-readable-pane[data-layout='mobile'] .human-readable-pane__frame--plain-text {
  overflow-wrap: anywhere;
  word-break: break-word;
}

.human-readable-pane[data-layout='mobile'] .human-readable-pane__frame--iframe {
  width: 100%;
  max-width: 100%;
  min-height: 16rem;
  height: min(var(--human-readable-pane-height, 30rem), 75vh);
}

@media (max-width: 576px) {
  .human-readable-pane__frame {
    padding: 0.75rem;
    resize: none;
    min-width: 0;
  }

  .human-readable-pane__frame--markdown,
  .human-readable-pane__frame--plain-text {
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  .human-readable-pane__frame--iframe {
    width: 100%;
    max-width: 100%;
    min-height: 16rem;
    height: min(var(--human-readable-pane-height, 30rem), 75vh);
  }
}
`, "",{"version":3,"sources":["webpack://./src/humanReadablePane.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,gDAAgD;EAChD,YAAY;EACZ,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;;;;EAIE,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,eAAe;EACf,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;AACd;;AAEA;;EAEE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,2DAA2D;AAC7D;;AAEA;EACE;IACE,gBAAgB;IAChB,YAAY;IACZ,YAAY;EACd;;EAEA;;IAEE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,2DAA2D;EAC7D;AACF","sourcesContent":[".human-readable-pane {\n  display: block;\n  min-width: 0;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.human-readable-pane__container {\n  display: block;\n  min-width: 0;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  overflow-x: hidden;\n}\n\n.human-readable-pane__frame {\n  display: block;\n  border: 1px solid;\n  padding: 1rem;\n  height: var(--human-readable-pane-height, 30rem);\n  min-width: 0;\n  max-width: 100%;\n  width: 100%;\n  box-sizing: border-box;\n  resize: both;\n  overflow: auto;\n}\n\n.human-readable-pane__frame--iframe {\n  padding: 0;\n  overflow: hidden;\n  width: 100%;\n  max-width: 100%;\n  min-height: 18rem;\n  background: var(--color-background, white);\n}\n\n.human-readable-pane__frame--markdown {\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.human-readable-pane__frame--plain-text {\n  font-family: monospace;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.human-readable-pane__frame--markdown > * {\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.human-readable-pane__frame--markdown img,\n.human-readable-pane__frame--markdown video,\n.human-readable-pane__frame--markdown canvas,\n.human-readable-pane__frame--markdown iframe {\n  max-width: 100%;\n  height: auto;\n}\n\n.human-readable-pane__frame--markdown pre,\n.human-readable-pane__frame--markdown code {\n  max-width: 100%;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.human-readable-pane__frame--markdown pre {\n  white-space: pre-wrap;\n}\n\n.human-readable-pane__frame--markdown table {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  overflow-x: auto;\n  box-sizing: border-box;\n}\n\n.human-readable-pane__frame--markdown th,\n.human-readable-pane__frame--markdown td {\n  white-space: normal;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.human-readable-pane[data-layout='mobile'] .human-readable-pane__frame {\n  padding: 0.75rem;\n  resize: none;\n  min-width: 0;\n}\n\n.human-readable-pane[data-layout='mobile'] .human-readable-pane__frame--markdown,\n.human-readable-pane[data-layout='mobile'] .human-readable-pane__frame--plain-text {\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.human-readable-pane[data-layout='mobile'] .human-readable-pane__frame--iframe {\n  width: 100%;\n  max-width: 100%;\n  min-height: 16rem;\n  height: min(var(--human-readable-pane-height, 30rem), 75vh);\n}\n\n@media (max-width: 576px) {\n  .human-readable-pane__frame {\n    padding: 0.75rem;\n    resize: none;\n    min-width: 0;\n  }\n\n  .human-readable-pane__frame--markdown,\n  .human-readable-pane__frame--plain-text {\n    overflow-wrap: anywhere;\n    word-break: break-word;\n  }\n\n  .human-readable-pane__frame--iframe {\n    width: 100%;\n    max-width: 100%;\n    min-height: 16rem;\n    height: min(var(--human-readable-pane-height, 30rem), 75vh);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
